import { GAME_SFX_CLICK_SELECT } from 'app/constants/GameSFX';

class ButtonSimple extends Phaser.Button {
  constructor({ game, id, sfxID, position, skin, ariaLabelID, spritesheet, defaultScale }) {
    super(game, 0, 0, spritesheet || 'buttons');
    this.setFrames(skin, skin, skin, skin);
    this.id = id;
    this.input.useHandCursor = true;
    this.game.time.events.add(10, this.init, this);
    this.grouped = position ? position.grouped : false;
    this.defaultScale = defaultScale || 1;
    if (!this.grouped) {
      if (position) {
        this.xpos = position.x;
        this.ypos = position.y;
      }
      this.anchor.set(0.5);
      this.updatePosition();
    }
    this.enable();
  }

  init() {
    // this.enable();
  }

  updatePosition() {
    this.position.set(this.game.width * this.xpos, this.game.height * this.ypos);
  }

  enable() {
    this.onInputDown.add(this.onDown, this);
    this.onInputOver.add(this.onOver, this);
    this.onInputOut.add(this.onOut, this);
  }

  disable() {
    this.onInputDown.forget();
    this.onInputDown.dispose();
    this.onInputDown.removeAll();
    this.onInputOver.forget();
    this.onInputOver.dispose();
    this.onInputOver.removeAll();
    this.onInputOut.forget();
    this.onInputOut.dispose();
    this.onInputOut.removeAll();
  }

  onOver() {
    this.scale.set(this.defaultScale * 1.2);
  }
  onOut() {
    this.scale.set(this.defaultScale * 1);
  }

  onDown() {
    this.game.sounds.playSFX(GAME_SFX_CLICK_SELECT);
  }

  destroy(destroyChildren = true) {
    this.disable();
    super.destroy(destroyChildren);
  }
}
export default ButtonSimple;
